import { Typography } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { Banner } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import type { Props } from './types';

function ScreeningErrors({ intl, errors, applicants, message }: Props) {
  const fullErrorMsg = errors ? (
    <Typography display={'block'} marginBottom={1}>
      <Typography component={'span'} fontWeight={'bold'} color={'error'}>
        Errors:
      </Typography>{' '}
      <Typography component={'span'} color={'error'}>
        {' '}
        {errors.join(' ')}
      </Typography>
    </Typography>
  ) : null;

  const fullApplicantList =
    applicants && applicants.length > 0 ? (
      <Typography display={'block'} marginBottom={1}>
        <Typography component={'span'} fontWeight={'bold'} color={'error'}>
          Applicants Needing Review:
        </Typography>{' '}
        <Typography component={'span'} color={'error'}>
          {applicants.join(', ')}
        </Typography>
      </Typography>
    ) : null;

  return (
    <Banner
      TypographyProps={{
        noWrap: false,
      }}
      text={
        <>
          {fullErrorMsg}
          {fullApplicantList}
          {message}
        </>
      }
      color={'red'}
      hasBorder={false}
    />
  );
}

export default ScreeningErrors;
